import { gotoAnchor } from '../../core/libs/ui-helper';

class FooterController {

  constructor($translate, authService, helperService) {
    'ngInject';
    Object.assign(this, { $translate, authService, helperService });
  }

  $onInit() {
    this.helperService.getCurrentLang()
      .then(lang => this.activeLanguage = lang);
    this.languages = [
      { key: 'en', value: 'English' },
      { key: 'es', value: 'Spanish' }
    ];
  }

  logOut() {
    this.authService.logOut();
  }

  changeLanguage() {
    this.helperService.changeLanguage(this.activeLanguage);
  }

  handleGotoAnchor() {
    gotoAnchor('header');
  }

}

export default FooterController;



// WEBPACK FOOTER //
// ./client/app/components/footer/footer.controller.js